import { switchWithYearSelectConstructor } from "scenes/cohort-filters/filter-configs/fieldContructors/switchWIthYearSelect";
import { Category } from "scenes/cohort-filters/filter-configs/categories";
import {
    dropdownFieldConfigConstructor,
    numberOrSelectFieldConstructor, rangeFieldConfigConstructor,
    switchFieldConstructor,
    switchWithAutoCompleteFieldConfigConstructor,
    switchWithSelectFieldConstructor,
} from "scenes/cohort-filters/filter-configs/fieldContructors";
import { switchWithAdditionalSwitchQuestionAndSelectRendererField } from "scenes/cohort-filters/filter-configs/fieldContructors/switchWithAdditionalSwitchQuestionAndSelectRendererFeild";
import { switchWithSelectAndTagsFieldConstructor } from "../../../filter-configs/fieldContructors/switchWithSelectAndTags";
import {nestedFieldConstructor} from "../../../filter-configs/fieldContructors/nestedField";

const cardiomypathyDiagnose = [
    { value: "DILATIVE", label: "anamnesis.cardio.haveCardiomypathyDiagnoseValue.DILATIVE" },
    { value: "ISCHAEMIC", label: "anamnesis.cardio.haveCardiomypathyDiagnoseValue.ISCHAEMIC" },
    { value: "OTHER", label: "anamnesis.cardio.haveCardiomypathyDiagnoseValue.OTHER" },
    { value: "UNCLEAR", label: "anamnesis.cardio.haveCardiomypathyDiagnoseValue.UNCLEAR" },
];
const atherosclerosisTreatment = [
    {
        value: "MEDICINAL",
        label: "anamnesis.cardio.MEDICINAL",
    },
    {
        value: "ZNSURGERY",
        label: "anamnesis.cardio.ZNSURGERY",
    },
    {
        value: "ZNSTENT",
        label: "anamnesis.cardio.ZNSTENT",
    },
];
const atherosclerosisLegArteriesStage = [
    {
        label: "anamnesis.cardio.STAGE_I",
        value: "STAGE_I",
    },
    {
        label: "anamnesis.cardio.STAGE_IIa",
        value: "STAGE_IIa",
    },
    {
        label: "anamnesis.cardio.STAGE_IIb",
        value: "STAGE_IIb",
    },
    {
        label: "anamnesis.cardio.STAGE_III",
        value: "STAGE_III",
    },
    {
        label: "anamnesis.cardio.STAGE_IV",
        value: "STAGE_IV",
    },
    {
        label: "anamnesis.cardio.ZNOP",
        value: "ZNOP",
    },
    {
        label: "anamnesis.cardio.ZNSTENT",
        value: "ZNSTENT",
    },
];
const restrictions = [
    { value: "NORMAL", label: "Normal" },
    { value: "SLIGHTLY_IMPAIRED", label: "slightly restricted" },
    { value: "MODERATELY_IMPAIRED", label: "moderately restricted" },
    { value: "HIGHLY_RESTRICTED", label: "highly restricted" },
];

export const cardiovascularDiseasesFields = {
    ...switchWithYearSelectConstructor({
        category: Category.CARDIOVASCULAR_DISEASES,
        pathToSwitchQuestion: "anamnesis.haveTransientIschemicAttack",
        pathToYearValue: "anamnesis.haveTransientIschemicAttackData.values.date",
        withEqualYear: true,
        label: "anamnesis.cardio.haveTransientIschemicAttack",
    }),
    ...switchWithSelectFieldConstructor({
        pathToSwitchQuestion: "anamnesis.haveCongenitalHeartDefect",
        pathToSelectValue: "anamnesis.haveCongenitalHeartDefectType",
        category: Category.CARDIOVASCULAR_DISEASES,
        label: "anamnesis.cardio.haveCongenitalHeartDefect",
        selectOptions: [
            {
                label: "VSD - Ventrikelseptumdefekt (Kammerseptumdefekt)",
                value: "VSD",
            },
            {
                label: "ASD - Atriumseptumdefekt (Vorhofseptumdefekt)",
                value: "ASD",
            },
            {
                label: "PDA - Persistierender Ductus arteriosus",
                value: "PDA",
            },
            {
                label: "PaV - Pulmonalklappenstenose",
                value: "PaV",
            },
            {
                label: "ISTA - Aortenisthmusstenose",
                value: "ISTA",
            },
            {
                label: "AoV - Aortenklappenstenose",
                value: "AoV",
            },
            {
                label: "TOF - Fallot-Tetralogie",
                value: "TOF",
            },
            {
                label: "AVSD - Atrioventrikulärer Septumdefekt",
                value: "AVSD",
            },
            {
                label: "TGA - Transposition der großen Gefäße",
                value: "TGA",
            },
            {
                label: "HLHS - Hypoplastisches Linksherzsyndrom",
                value: "HLHS",
            },
            {
                label: "PA+VSD - Pulmonalatresie mit Ventrikelseptumdefekt",
                value: "PAVSD",
            },
            {
                label: "PA - Pulmonalatresie ohne Ventrikelseptumdefekt",
                value: "PA",
            },
            {
                label: "TrA - Trikuspidalatresie",
                value: "TrA",
            },
            {
                label: "DIV - Double inlet ventricle (singulärer Ventrikel)",
                value: "DIV",
            },
            {
                label: "DORV - Double outlet right ventricle",
                value: "DORV",
            },
            {
                label: "ccTGA - Angebore",
                value: "ccTGA",
            },
            {
                label: "TAC - Truncus arteriosus communis",
                value: "TAC",
            },
            {
                label: "HOCM - Hypertrophe obstruktive Kardiomyopathie",
                value: "HOCM",
            },
            {
                label: "Suprav. AS - Supravalvuläre Aortenstenose (Williams-Beuren-Syndrom)",
                value: "SupravAS",
            },
        ],
    }),
    ...switchWithSelectFieldConstructor({
        category: Category.CARDIOVASCULAR_DISEASES,
        pathToSwitchQuestion: "anamnesis.haveSufferFromHeartFailure",
        label: "anamnesis.cardio.haveSufferFromHeartFailure",
        selectLabel: "anamnesis.cardio.haveSufferFromHeartFailureDecompensation.statementLabel",
        pathToSelectValue: "anamnesis.haveSufferFromHeartFailureDecompensation",
        selectOptions: [
            {
                label: "< 3",
                value: "<3",
            },
            {
                label: "3-5",
                value: "3-5",
            },
            {
                label: "> 5",
                value: ">5",
            },
        ],
    }),
    ...numberOrSelectFieldConstructor({
        category: Category.CARDIOVASCULAR_DISEASES,
        pathToValue: "anamnesis.haveCardiacEjectionFraction",
        pathToNumValue: "anamnesis.haveCardiacEjectionFractionPercent",
        pathToSelectValue: "anamnesis.haveCardiacEjectionFractionDescription",
        withComparisonOperators: false,
        label: "anamnesis.cardio.haveCardiacEjectionFraction",
        selectOptions: restrictions,
    }),
    ...switchWithYearSelectConstructor({
        category: Category.CARDIOVASCULAR_DISEASES,
        label: "anamnesis.cardio.haveMyocardialBiopsy",
        pathToSwitchQuestion: "anamnesis.haveMyocardialBiopsy",
        pathToYearValue: "anamnesis.haveMyocardialBiopsyData.values.date",
    }),
    ...nestedFieldConstructor({
        category: Category.CARDIOVASCULAR_DISEASES,
        label: "anamnesis.cardio.haveStroke",
        nestedPath: "$haveStrokeData$anamnesis.haveStrokeData.values",
        allowOrCondition: true,
        canExclude: true,
        nestedConfigs: [
            switchFieldConstructor({
                nestedComponent: true,
                pathToValue: "$nestedHaveStroke$anamnesis.haveStroke",
            }),
            dropdownFieldConfigConstructor({
                pathToValue: "anamnesis.haveStrokeData.values.value",
                label: "anamnesis.cardio.haveStrokeSubInnerQuestion",
                nestedComponent: true,
                dropdownValues: Object.freeze([
                    {value: "Ischaemic", label: "anamnesis.cardio.Ischaemic"},
                    {value: "Bleeding", label: "anamnesis.cardio.Bleeding"},
                    {value: "Unknown", label: "anamnesis.cardio.Unknown"},
                ]),
                fieldWidth: 150,
            }),
            rangeFieldConfigConstructor({
                nestedComponent: true,
                pathToValue: "anamnesis.haveStrokeData.values.date",
                label: "Date",
                isDate: true,
                fieldWidth: 100,
            }),
        ],
    }),
    ...switchFieldConstructor({
        category: Category.CARDIOVASCULAR_DISEASES,
        pathToValue: "anamnesis.hasEnlargementOfTheAorta",
        label: "anamnesis.cardio.hasEnlargementOfTheAorta",
    }),
    ...switchWithAdditionalSwitchQuestionAndSelectRendererField({
        category: Category.CARDIOVASCULAR_DISEASES,
        pathToSwitchQuestion: "anamnesis.haveCardiacArrhythmia",
        pathToSelectValue: "anamnesis.haveCardiacArrhythmiaType",
        selectOptions: [
            {
                value: "ATRIAL_FIBRILLATION",
                label: "anamnesis.cardio.haveCardiacArrhythmiaType.ATRIAL_FIBRILLATION",
            },
            {
                value: "ATRIAL_FLUTTER",
                label: "anamnesis.cardio.haveCardiacArrhythmiaType.ATRIAL_FLUTTER",
            },
            {
                value: "VENTRICULAR_EXTRASYSTOLE",
                label: "anamnesis.cardio.haveCardiacArrhythmiaType.VENTRICULAR_EXTRASYSTOLE",
            },
            {
                value: "VENTRICULAR_TACHYCARDIA",
                label: "anamnesis.cardio.haveCardiacArrhythmiaType.VENTRICULAR_TACHYCARDIA",
            },
            {
                value: "AVNRT",
                label: "anamnesis.cardio.haveCardiacArrhythmiaType.AVNRT",
            },
            {
                value: "OTHER",
                label: "anamnesis.cardio.haveCardiacArrhythmiaType.OTHER",
            },
            {
                value: "UNKNOWN",
                label: "anamnesis.cardio.haveCardiacArrhythmiaType.UNKNOWN",
            },
        ],
        pathToSecondSwitchQuestion: "anamnesis.haveResuscitated",
        label: "anamnesis.cardio.haveCardiacArrhythmia",
        secondSwitchLabel: "anamnesis.cardio.haveResuscitated",
    }),
    ...switchWithYearSelectConstructor({
        category: Category.CARDIOVASCULAR_DISEASES,
        pathToYearValue: "anamnesis.haveMiocardialHeartAttackData.values.date",
        pathToSwitchQuestion: "anamnesis.haveMiocardialHeartAttack",
        withEqualYear: true,
        pathToNumberOfEntries: "anamnesis.haveMiocardialHeartAttackData.values_count",
        label: "anamnesis.cardio.haveMiocardialHeartAttack",
    }),
    ...switchWithSelectFieldConstructor({
        pathToSwitchQuestion: "anamnesis.haveAtherosclerosis",
        pathToSelectValue: "anamnesis.haveAtherosclerosisValue",
        category: Category.CARDIOVASCULAR_DISEASES,
        label: "anamnesis.cardio.haveAtherosclerosis",
        selectOptions: atherosclerosisTreatment,
    }),
    ...switchFieldConstructor({
        category: Category.CARDIOVASCULAR_DISEASES,
        pathToValue: "anamnesis.haveAtherosclerosisLegArteries",
        label: "anamnesis.cardio.haveAtherosclerosisLegArteries",
    }),
    ...switchWithSelectFieldConstructor({
        category: Category.CARDIOVASCULAR_DISEASES,
        pathToSwitchQuestion: "anamnesis.haveAtherosclerosisLegArteries",
        pathToSelectValue: "anamnesis.haveAtherosclerosisLegArteriesStage",
        label: "anamnesis.cardio.haveAtherosclerosisLegArteries",
        selectOptions: atherosclerosisLegArteriesStage,
    }),
    ...switchWithSelectFieldConstructor({
        category: Category.CARDIOVASCULAR_DISEASES,
        pathToSwitchQuestion: "anamnesis.coronaryArteryDisease",
        pathToSelectValue: "anamnesis.coronaryArteryDiseaseState",
        label: "anamnesis.cardio.coronary-artery-disease",
        selectOptions: [
            { value: "1_VESSEL_AFFECTED", label: "anamnesis.cardio.1_VESSEL_AFFECTED" },
            { value: "2_VESSELS_AFFECTED", label: "anamnesis.cardio.2_VESSELS_AFFECTED" },
            { value: "3_VESSELS_AFFECTED", label: "anamnesis.cardio.3_VESSELS_AFFECTED" },
        ],
    }),
    ...switchWithYearSelectConstructor({
        category: Category.CARDIOVASCULAR_DISEASES,
        label: "anamnesis.cardio.havePlumonaryArteryEmbolism",
        pathToSwitchQuestion: "anamnesis.havePlumonaryArteryEmbolism",
        pathToYearValue: "anamnesis.havePlumonaryArteryEmbolismData.values.date",
        withEqualYear: true,
    }),
    ...switchWithSelectFieldConstructor({
        category: Category.CARDIOVASCULAR_DISEASES,
        pathToSwitchQuestion: "anamnesis.haveCardiomypathy",
        pathToSelectValue: "anamnesis.haveCardiomypathyDiagnoseValue",
        label: "anamnesis.cardio.haveCardiomypathy",
        selectOptions: cardiomypathyDiagnose,
    }),
    ...switchWithAutoCompleteFieldConfigConstructor({
        category: Category.CARDIOVASCULAR_DISEASES,
        pathToSelectValues: "anamnesis.haveAtherosclerosisStentImplantationData.values.value",
        pathToSwitchQuestion: "anamnesis.haveAtherosclerosisStentImplantation",
        autocompleteLabel: "anamnesis.cardio.howManyStentsQuestion",
        fieldLabel: "anamnesis.cardio.stent-for-atherosclerosis",
    }),
    ...switchWithSelectAndTagsFieldConstructor({
        category: Category.CARDIOVASCULAR_DISEASES,
        pathToValue: "anamnesis.CARDIO_DISEASE",
        pathToSwitchQuestion: "anamnesis.haveValvularHeartDisease",
        pathToSelectValue: "",
        label: "anamnesis.cardio.valvularHeartDisease",
        selectOptions: [],
        tagsValues: [
            { value: "hasAorticInsufficiency", label: "anamnesis.cardio.valvularHeartDiseaseType.hasAorticInsufficiency" },
            { value: "hasAorticStenosis", label: "anamnesis.cardio.valvularHeartDiseaseType.hasAorticStenosis" },
            { value: "hasMitralValveInsufficiency", label: "anamnesis.cardio.valvularHeartDiseaseType.hasMitralValveInsufficiency" },
            { value: "hasMitralValveStenosis", label: "anamnesis.cardio.valvularHeartDiseaseType.hasMitralValveStenosis" },
            { value: "hasPulmonicValveInsufficiency", label: "anamnesis.cardio.valvularHeartDiseaseType.hasPulmonicValveInsufficiency" },
            { value: "hasPulmonaryValveStenosis", label: "anamnesis.cardio.valvularHeartDiseaseType.hasPulmonaryValveStenosis" },
            { value: "hasTricuspidValveInsufficiency", label: "anamnesis.cardio.valvularHeartDiseaseType.hasTricuspidValveInsufficiency" },
            { value: "hasTricuspidValveStenosis", label: "anamnesis.cardio.valvularHeartDiseaseType.hasTricuspidValveStenosis" },
        ],
    }),
    ...nestedFieldConstructor({
        category: Category.CARDIOVASCULAR_DISEASES,
        label: "anamnesis.cardio.heartValveTreatment",
        nestedPath: "$heartValveTreatment$anamnesis.haveHeartValveTreatmentData.values",
        allowOrCondition: true,
        canExclude: true,
        nestedConfigs: [
            switchFieldConstructor({
                nestedComponent: true,
                pathToValue: "$nestedHaveHeartValveTreatment$anamnesis.haveHeartValveTreatment",
            }),
            rangeFieldConfigConstructor({
                nestedComponent: true,
                pathToValue: "anamnesis.haveHeartValveTreatmentData.values.date",
                label: "Date",
                isDate: true,
                fieldWidth: 100,
            }),
            dropdownFieldConfigConstructor({
                pathToValue: "anamnesis.haveHeartValveTreatmentData.values.type1",
                label: "global.intervention",
                nestedComponent: true,
                dropdownValues: Object.freeze([
                    {value: "OPERATIVE", label: "anamnesis.cardio.haveHeartValveTreatmentData.OPERATIVE"},
                    {value: "INTERVENTIONAL", label: "anamnesis.cardio.haveHeartValveTreatmentData.INTERVENTIONAL"}
                ]),
                fieldWidth: 150,
            }),
            dropdownFieldConfigConstructor({
                pathToValue: "anamnesis.haveHeartValveTreatmentData.values.type2",
                label: "global.valve-involved",
                nestedComponent: true,
                dropdownValues: Object.freeze([
                    {
                        value: "AORTIC_VALVE",
                        label: 'anamnesis.cardio.haveHeartValveTreatmentData.AORTIC_VALVE'
                    },
                    {
                        value: "MITRAL_VALVE",
                        label: 'anamnesis.cardio.haveHeartValveTreatmentData.MITRAL_VALVE'
                    },
                    {
                        value: "PULMONIC_VALVE",
                        label: 'anamnesis.cardio.haveHeartValveTreatmentData.PULMONIC_VALVE'
                    },
                    {
                        value: "TRICUSPID_VALVE",
                        label: 'anamnesis.cardio.haveHeartValveTreatmentData.TRICUSPID_VALVE'
                    }
                ]),
                fieldWidth: 200,
            }),
        ],
    }),
};
/**
 * haveHeartValveTreatmentData
 */
